import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import LoginPage from './pages/LoginPage';
import AdminLayout from './components/AdminLayout';
import ClubsPage from './pages/admin/ClubsPage';
import ClubDetailPage from './pages/admin/ClubDetailPage';

export default function AdminApp() {
    return (
        <BrowserRouter>
            <UnauthenticatedTemplate>
                <LoginPage />
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <AdminLayout>
                    <Routes>
                        <Route path="/" element={<Navigate to="/admin/clubs" replace />} />
                        <Route path="/admin/clubs" element={<ClubsPage />} />
                        <Route path="/admin/clubs/:id" element={<ClubDetailPage />} />
                        <Route path="*" element={<Navigate to="/admin/clubs" replace />} />
                    </Routes>
                </AdminLayout>
            </AuthenticatedTemplate>
        </BrowserRouter>
    );
}